femcare.callToActionSignpost = {

    init: function () {
        var $modalTriggers = $('.signpost-topic-item__call-to-action a[modal-target]');

        if ($modalTriggers.length) {
            $modalTriggers.each(function (index, element) {
                var $trigger = $(element);
                var modalSelector = $trigger.attr('modal-target');
                var $modal = $(modalSelector);
                if ($modal.length) {
                    $trigger.on('click', function (event) {
                        event.preventDefault();
                        $modal.modal();
                    });
                }
            });
        }
    }
};